const localDateTime = new Date()?.toISOString();
const localString = '';
//const localInt = 0;

export const apartmentReceiptPaymentFileModelGet = (
    id = localString,
    buildingId = localString,
    apartmentId = localString,
    receiptId = localString,
    apartmentReceiptId = localString,
    apartmentReceiptPaymentId = localString,
    userId = localString,
    files = []) => {
    return {
        id: id,
        buildingId: buildingId,
        apartmentId: apartmentId,
        receiptId: receiptId,
        apartmentReceiptId: apartmentReceiptId,
        apartmentReceiptPaymentId: apartmentReceiptPaymentId,
        userId: userId,
        created: localDateTime,
        files: files,
    }
}